<template>
    <div style="background: #FFFFFF;min-height:calc(100vh - 110px);">
      <div class="accountView">
        <usp-tabs v-model="activeIndex" @tab-click="handleSelect">
          <usp-tab-pane label="全部消息" class="usp-tab-pane-tittle" name='all' bottomLineWidth="16">
          </usp-tab-pane>
          <usp-tab-pane label="未读消息" class="usp-tab-pane-tittle" name="0" bottomLineWidth="16">
          </usp-tab-pane>
          <usp-tab-pane label="已读消息" class="usp-tab-pane-tittle" name="1" bottomLineWidth="16">
          </usp-tab-pane>
        </usp-tabs>
        <div v-show="list.length > 0" style="width: 100%">
          <div
              v-for="(item, index) in list"
              :key="'list' + index"
              class="item-tittle-div" >
            <div class="item-tittle" @click="toDetail(item)">
              <div v-if="item.status === 0" class="item-spot"></div>
              <p v-html="item.content"></p>
            </div>
            <div class="item-div">
              <div class="item-author-div">
                <img class="item-headPortrait" :src="!item.headPortrait || item.headPortrait === ''? require('@/assets/img/forum/forum_user.png') : item.headPortrait" alt="">
                <div class="item-userName">{{item.from}}</div>
                <div class="item-publishTime">{{timeFormatSeconds(item.createTime)}}</div>
              </div>
              <div class="button-div">
                <button class="cancelCollection" @click="readClick(item.letterId, 1)">
                  标记为已读
                </button>
                  <button class="cancelCollection" @click="readClick(item.letterId, 0)">
                  标记为未读
                </button>
                  <button class="del-button" @click="delectClick(item.letterId)">
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-show="list.length < 1" style="width: 100%;text-align: center;padding: 20px;box-sizing: border-box">
          <img src="@/assets/img/pages/nodata.png" style="height: 250px;" alt="">
        </div>
        <div class="pagination">
          <el-pagination
              background
              :hide-on-single-page="true"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, total, jumper"
              :total="total"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
      <el-dialog
        title=""
        :visible.sync="detailDialog"
        width="50%"
        :before-close="handleDetailClose"
        :close-on-click-modal="false">
        <!-- <el-row style="line-height: 22px; margin-bottom: 10px">
          <el-col :span="16" class="detail-title">{{detailData.title}}</el-col>
          <el-col :span="8" style="text-align: end">管理员&nbsp;{{timeFormatSeconds(detailData.createTime)}}</el-col>
        </el-row>
        <el-row>
          <p v-html="detailData.content"></p>
        </el-row> -->
        <el-row style="line-height: 22px; margin-bottom: 10px; font-size: 18px; font-weight: 600; text-align: center;">
          {{detailData.title}}
        </el-row>
        <el-row style="line-height: 22px; margin-bottom: 10px; font-size: 12px; text-align: center;">
          管理员&nbsp;{{timeFormatSeconds(detailData.createTime)}}
        </el-row>
        <el-row style="padding: 10px 40px 20px 40px; text-align: left;">
          <p v-html="detailData.content"></p>
        </el-row>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="detailDialog = false">
            我知道了
          </el-button>
        </el-row>
      </el-dialog>
    </div>
</template>
<script>
import UspTabPane from '@/components/uaesTabs/tab-pane'
import UspTabs from '@/components/uaesTabs/tabs'
import { timeFormatSeconds } from '@/scripts/dataTimeUtils'
// import timUtils from '@/utils/tim-utils'
import { timLogin } from '@/utils/tim-utils'
import { getLetterPage, letterDelete, readLetter } from '@/api/modules/timeUtils'
export default {
  components: {
    UspTabPane,
    UspTabs
  },
  data() {
    return {
      activeIndex: 'all',
      userInfo: {},
      list: [],
      total: '',
      currentPage: 1,
      pageSize: 10,
      detailDialog: false,
      detailData: {}
    }
  },
  async created() {
    const user = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    this.userInfo = user
    timLogin()
    this.getList()
  },
  methods: {
    handleSelect(e) {
      this.currentPage = 1
      this.pageSize = 10
      this.activeIndex = e.name
      this.getList()
    },
    async getList() {
      const res = await getLetterPage({ user: this.userInfo.id, pageIndex: this.currentPage, pageSize: this.pageSize, status: this.activeIndex === 'all' ? '' : this.activeIndex })
      if (res.code === 0) {
        this.list = res.data.dataList
        this.total = res.data.page.totalCount
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    timeFormatSeconds(time) {
      return timeFormatSeconds(time)
    },
    handleCurrentChange() {
      this.getList()
    },
    async delectClick(id) {
      const that = this
      this.$confirm('是否删除当前信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.delect(id)
      }).catch(() => {
      })
    },
    async delect(id) {
      const res = await letterDelete({ letterIds: [id], user: this.userInfo.id })
      if (res.code === 0) {
        this.$message({
          message: '删除成功！',
          type: 'success'
        })
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async readClick(id, status) {
      const that = this
      this.$confirm(`是否将该消息改为${status === 1 ? '已读' : '未读'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.readLetter(id, status)
      }).catch(() => {
      })
    },
    async readLetter(id, status) {
      const res = await readLetter({ letterIds: [id], user: this.userInfo.id, status: status })
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    toDetail(data) {
      this.detailData = data
      this.detailDialog = true
      if (data.status === 0) {
        readLetter({ letterIds: [data.letterId], user: this.userInfo.id, status: 1 })
      }
    },
    detailClose() {
      this.handleDetailClose()
    },
    handleDetailClose() {
      this.detailData = {}
      this.detailDialog = false
    }
  }
}
</script>
<style lang="less" scoped>
.accountView {
  padding: 26px 34px;
  height: 100%;
}
::v-deep .el-tabs__nav-wrap::after {
  background:none;
}
/deep/ .el-tabs__item {
  font-size: 18px !important;
}
/deep/ .el-tabs__active-bar {
  height: 4px;
}
.item-tittle-div {
  border-bottom: 1px solid #DDDDDD;
  padding: 20px 0px;
  box-sizing: border-box;
}
.item-spot{
  width: 8px;
  height: 8px;
  background: #FF0000;
  border-radius: 50%;
  margin-right: 10px;
}
.item-tittle {
  font-size: 20px;
  font-weight: 400;
  color: #2F374B;
  cursor: pointer;
  display: flex;
  align-content: center;
  align-items: center;
}
/deep/ .item-tittle > p > p{
  margin: 0px
}
.tab1{
  display: inline-block;
  border: 1px solid #EFA13E;
  border-radius: 12px;
  color: #EFA13E;
  min-width: 52px;
  font-size: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 7px;
  cursor: default;
  background-color: #FEF7EE;
}
.item-div {
  height: 50%;
  padding-top: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between
}
.item-author-div {
  width: 600px;
  display: flex;
  align-items: center;
  align-items: center;
  align-content: center;
}
.item-headPortrait {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.item-userName {
  padding-left: 12px;
  font-size: 14px;
  font-weight: 400;
  color: #2F374B;
}
.item-publishTime {
  padding-left: 46px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.button-div{
  visibility:hidden;
}
.item-tittle-div:hover .button-div{
  visibility: visible;
}
.cancelCollection{
  padding: 11px 24px;
  background: #FFFFFF;
  border: 1px solid #4D78FF;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #4D78FF;
  margin-left: 14px;
  cursor: pointer;
}
.del-button{
  padding: 11px 29px;
  background: #FFFFFF;
  border: 1px solid #FF0000;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #FF0000;
  margin-left: 14px;
  cursor: pointer;
}

.pagination {
  padding: 28px 0;
  text-align: right;
}
::v-deep .el-dialog {
  border-radius: 8px;
}
::v-deep .el-dialog__body {
  padding: 15px 30px 30px 30px;
}
::v-deep .el-dialog__headerbtn {
  top: 15px;
  right: 15px;
}
.detail-title {
  font-size: 18px;
  font-weight: 600;
}
</style>
